<template>
  <l-control :position="position" class="custom-control-legends">
    <b-table-lite :fields="fields" :items="items" thead-class="d-none" borderless small>
      <template #cell(colour)="data">
        <div :style="{ 'background-color': data.item.colour }" class="legendColor align-baseline" />
      </template>
    </b-table-lite>
  </l-control>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import { LControl } from 'vue2-leaflet'

const components = {
  LControl,
}

const props = {
  position: {
    type: String,
    default: 'bottomleft',
  },
}

@Component({ components })
export default class MapLegends extends Vue.extend({ props }) {
  fields = [{ key: 'colour' }, { key: 'range' }]

  get formatValueByTotalUnit() {
    return this.$typedStore.visualisationData.formatValueByTotalUnit
  }

  get legends() {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.mapConfig.legends
  }

  get items() {
    return this.legends.map((obj, index, array) => {
      return {
        range:
          this.formatValueByTotalUnit(+obj.range) +
          (array[index + 1] ? ' - ' + this.formatValueByTotalUnit(+array[index + 1].range) : '+'),
        colour: obj.colour,
      }
    })
  }
}
</script>

<style scoped>
.legendColor {
  width: 1rem;
  height: 1rem;
  border: 1px solid #666;
  align-items: middle;
}

.custom-control-legends {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 5px;
}
</style>
